import React from 'react';
import { arrayAddIndexAsId } from '@strava/utils';
import { Markup } from 'interweave';
import LegacySpriteToStravaUiIcon from './components/LegacySpriteToStravaUiIcon';
import { useLoggedOutAthletePageContext } from '../../state/LoggedOutAthletePageContext';

import styles from './Achievements.module.scss';

const Achievements = () => {
  const { state, t } = useLoggedOutAthletePageContext();
  const { athleteData } = state;
  const { achievements } = athleteData;

  if (achievements.length === 0) {
    return null;
  }

  return (
    <div className={styles.athleteAchievements}>
      <h3>{t('recent_achievements')}</h3>
      <ul>
        {arrayAddIndexAsId(achievements).map(
          ({ showTrophy, spriteName, description, timeago, id }) => (
            <li key={id}>
              {showTrophy ? (
                <div className={styles.sprite} data-testid="achievement-icon">
                  <LegacySpriteToStravaUiIcon sprite={spriteName} />
                </div>
              ) : null}
              <div className={styles.description}>
                <div className={styles.title}>{description}</div>
                <Markup className={styles.timestamp} content={timeago} />
              </div>
            </li>
          )
        )}
      </ul>
    </div>
  );
};

export default Achievements;
